import Permission from '@/classes/Permission'

export default {
  bind(el, binding, vnode) {
    let operation = binding.value
    let permission = Permission.loadPermissions()
    let can = Permission.can(permission, operation)

    if (operation != undefined && can === false) {
      el.innerHTML = ""
      el.style.display = "none"
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/Can.js